import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { Table, Grid, Row, Col } from 'react-bootstrap';
import { fetchDatabases } from '../../actions/DataActions';
import s from './DataPage.css';

const giantCompendia = [
  {
    id: 1,
    title: 'Human Compendium (GIANT v1, 2015)',
    count: 990,
    file: 'human_compendium.tsv',
  },
];

const DataPage = ({ databases, dispatch }) => {
  useEffect(() => {
    dispatch(fetchDatabases());
  }, [dispatch]);

  const databaseRow = db => (
    <tr key={db.url}>
      <td style={{ width: 275, verticalAlign: 'middle' }}>{db.name}</td>
      <td style={{ verticalAlign: 'middle' }}>
        {db.term_version} {db.annotation_version}
      </td>
    </tr>
  );

  const compendiumRow = compendium => (
    <tr key={compendium.id}>
      <td style={{ verticalAlign: 'middle' }}>{compendium.title}</td>
      <td style={{ verticalAlign: 'middle' }}>
        {compendium.count.toLocaleString()}
      </td>
      <td style={{ verticalAlign: 'middle' }}>
        <a href={`/static/${compendium.file}`} download>
          {compendium.file}
        </a>
      </td>
    </tr>
  );

  return (
    <div className={s.root}>
      <Grid>
        <h1>HumanBase Data Sources</h1>
        <br />
        <h2>
          Term definitions
          <br />
          <small>Ontology definitions</small>
        </h2>
        <Table striped>
          <thead>
            <tr>
              <th>Name</th>
              <th>Version</th>
            </tr>
          </thead>
          <tbody>
            {databases.filter(db => db.term_version !== '').map(databaseRow)}
          </tbody>
        </Table>
        <h2>
          Gene annotations
          <br />
          <small>
            Gene-term associations used in enrichment analyses, term
            predictions, etc.
          </small>
        </h2>
        <Table striped>
          <thead>
            <tr>
              <th>Name</th>
              <th>Version</th>
            </tr>
          </thead>
          <tbody>
            {databases
              .filter(db => db.annotation_version !== '')
              .map(databaseRow)}
          </tbody>
        </Table>
        <Row>
          <Col md={12}>
            <h2>
              GIANT data compendia
              <br />
              <small>
                Genomics datasets used in the network integrative analyses
              </small>
            </h2>
            <Table striped>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Dataset Count</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>{giantCompendia.map(compendiumRow)}</tbody>
            </Table>
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

DataPage.propTypes = {
  databases: PropTypes.arrayOf(PropTypes.object),
  dispatch: PropTypes.func.isRequired,
};

DataPage.defaultProps = {
  databases: [],
};

const select = state => ({
  databases: state.data.databases,
});

export default connect(select)(withStyles(s)(DataPage));
